import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import cn from 'classnames';
import {
  CognitoUserPool,
  CognitoUser,
} from 'amazon-cognito-identity-js';

import Header from 'components/Header';
import Footer from 'components/Footer';
import FormGroup from 'components/Form/FormGroup';
import { Grid, Column } from 'components/Layout';
import Input from 'components/Form/Input';
import Validator from 'components/Validator/Validator';
import { Button } from 'components/Button';
import Card from 'components/Card';
import { appConfig } from 'config/appConfig';

import schema from './forgotSchema';
import emailFormSchema from './emailFormSchema';
import style from './style.scss';

const Forgot = (props) => {
  const { validator: { values, errors } } = props;
  const [error, setError] = useState('');
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [cognitoUser, setCognitoUser] = useState(null);

  useEffect(() => {
    const resetUser = localStorage.getItem('reset-user');
    if (resetUser) { // reset password required
      localStorage.removeItem('reset-user');
      const poolData = {
        UserPoolId: appConfig.userPoolId,
        ClientId: appConfig.clientId,
      };
      const userPool = new CognitoUserPool(poolData);

      const userData = {
        Username: resetUser,
        Pool: userPool,
      };

      const cognitoUserTemp = new CognitoUser(userData);

      setIsLoading(true);
      cognitoUserTemp.forgotPassword({
        onSuccess: (result) => { // eslint-disable-line
          setIsLoading(false);
          setStep(2);
          setCognitoUser(cognitoUserTemp);
        },
        onFailure: (err) => {
          setError(err.message);
          setIsLoading(false);
        },
        // inputVerificationCode() {
        // },
      });
    }
  }, []);

  const handleInputChange = (event) => {
    const { validator: { onChangeHandler } } = props;
    onChangeHandler(event.target.name, event.target.value.trim());
  };

  const handleSubmitFrom = (e) => {
    e.preventDefault();
    const { validator: { validate } } = props;

    if (validate(emailFormSchema).isValid) {
      const poolData = {
        UserPoolId: appConfig.userPoolId,
        ClientId: appConfig.clientId,
      };
      const userPool = new CognitoUserPool(poolData);

      const userData = {
        Username: values.username,
        Pool: userPool,
      };

      const cognitoUserTemp = new CognitoUser(userData);

      setIsLoading(true);
      cognitoUserTemp.forgotPassword({
        onSuccess: (result) => { // eslint-disable-line
          setStep(2);
          setError('');
          setCognitoUser(cognitoUserTemp);
          setIsLoading(false);
        },
        onFailure: (err) => {
          setError(err.message);
          setIsLoading(false);
        },
        // inputVerificationCode() {
        // },
      });
    }
  };

  const handleResetPassword = (data, e) => {
    e.preventDefault();

    const { validator: { validate }, history } = props;
    if (validate(schema).isValid) {
      setIsLoading(true);
      cognitoUser.confirmPassword(values.verificationCode, values.newPassword, {
        onSuccess: (result) => { // eslint-disable-line
          history.replace('/');
        },
        onFailure: (err) => { // eslint-disable-line
          setError(err.message || '');
          setIsLoading(false);
        },
      });
    }
  };

  return (
    <Fragment>
      <Header />
      <form onSubmit={handleSubmitFrom}>
        <section className={cn('grid-container fluid portal borrowers-apply section', style.loginContainer)}>
          <div className={cn('grid-container', style.innerLogin)}>
            <Grid className="grid-margin-x max-limited">
              <Column className="small-12 large-12">
                <FormGroup className="form-group">
                  <Grid className="grid-margin-x">
                    <Column className={cn('small-12 medium-12', style.relativeDiv)}>
                      <label className={style.error}>{error}</label>
                      <Grid className="grid-margin-x card-grid-container">
                        <Column className="small-12 medium-12">
                          <Card
                            title="Reset Password"
                            isSectionWrapped
                          >
                            {
                              step === 1 ?
                                <Fragment>
                                  <Input
                                    name="username"
                                    label="Username"
                                    onChange={handleInputChange}
                                    value={values.username}
                                    hasError={!!errors.username}
                                    hasValue
                                    placeHolder="username"
                                    isBadgeVisible={false}
                                    isRequired
                                    isDisabled={isLoading}
                                    errorMessage={errors.username}
                                  />
                                </Fragment>
                              :
                                <Fragment>
                                  <p>
                                    Your request was received. If {values.username} is registered in our system, you will receive instructions to reset your password in the next few minutes. Please remember to check your spam or junk folder, too!
                                  </p>
                                  <Grid className="grid-margin-x">
                                    <Column className="small-12 large-12">
                                      <Input
                                        name="verificationCode"
                                        label="Verification Code"
                                        onChange={handleInputChange}
                                        value={values.verificationCode}
                                        hasError={!!errors.verificationCode}
                                        hasValue
                                        placeHolder="Verification Code"
                                        isBadgeVisible={false}
                                        isRequired
                                        errorMessage={errors.verificationCode}
                                      />
                                    </Column>
                                    <Column className="small-12 large-12">
                                      <Input
                                        name="newPassword"
                                        type="password"
                                        label="New Password"
                                        onChange={handleInputChange}
                                        value={values.newPassword}
                                        hasError={!!errors.newPassword}
                                        hasValue
                                        placeHolder="New Password"
                                        isBadgeVisible={false}
                                        isRequired
                                        errorMessage={errors.newPassword}
                                      />
                                    </Column>
                                    <Column className="small-12 large-12">
                                      <Input
                                        name="confirmPassword"
                                        type="password"
                                        label="Confirm Password"
                                        onChange={handleInputChange}
                                        value={values.confirmPassword}
                                        hasError={!!errors.confirmPassword}
                                        hasValue
                                        placeHolder="Confirm Password"
                                        isBadgeVisible={false}
                                        isRequired
                                        errorMessage={errors.confirmPassword}
                                      />
                                    </Column>
                                  </Grid>
                                </Fragment>
                            }
                          </Card>
                        </Column>
                        <Column className="small-12 medium-12">
                          {
                            step === 1 ?
                              <Button
                                className={cn('button small green w-100', style.button)}
                                onClick={handleSubmitFrom}
                                isLoading={isLoading}
                              >
                                Send Verification Code
                              </Button>
                            :
                              <Button
                                className={cn('button small green w-100', style.button)}
                                onClick={handleResetPassword.bind(null, values)}
                                isLoading={isLoading}
                              >
                                Reset Password
                              </Button>
                          }
                        </Column>
                      </Grid>
                    </Column>
                  </Grid>
                </FormGroup>
              </Column>
            </Grid>
          </div>
        </section>
      </form>
      <Footer />
    </Fragment>
  );
};

Forgot.propTypes = {
  validator: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default compose(
  withRouter,
  Validator(schema)
)(Forgot);



// WEBPACK FOOTER //
// ./src/containers/pages/Auth/Forgot.js